<template>
    <div>
        <div class="office">
            <div class="office_main">
                <div class="office_sky">
                    <div class="office_imgs">
                        <p>{{ $t('office_title') }}</p>
                        <img
                            :class="index == '0' ? 'office_imgs_big' : 'office_imgs_little'"
                            v-for="(item, index) in office_imgs"
                            :key="index"
                            :src="item"
                            alt=""
                        />
                    </div>
                    <el-form class="office_form">
                        <p>{{ $t('office_form_label1') }}</p>
                        <el-form-item :label="$t('your_name')">
                            <el-input v-model="temp.name"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('e_mail')">
                            <el-input v-model="temp.email"></el-input>
                        </el-form-item>
                        <div class="code-phone">
                            <el-form-item :label="$t('intl_code')" class="office_form_code office-number">
                                <el-select
                                    v-model="temp.qz"
                                    :popper-append-to-body="false"
                                    popper-class="optionsContents"
                                    placeholder=""
                                >
                                    <el-option
                                        v-for="(item, i) in areaCode"
                                        :key="i"
                                        :value="item.phone_code"
                                        :label="' +' + item.phone_code"
                                        >{{ $i18n.locale == 'chinese' ? item.chinese_name : item.english_name }} +{{
                                            item.phone_code
                                        }}</el-option
                                    >
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('mobile_number')" class="office_form_number">
                                <el-input v-model="temp.phone"></el-input>
                            </el-form-item>
                        </div>

                        <el-form-item :label="$t('office_form_label6')" class="office_form_msg">
                            <el-input type="textarea" maxlength="600" show-word-limit v-model="temp.message" resize="none"></el-input>
                        </el-form-item>
                        <el-button class="office_sub" @click="commit">{{ $t('office_form_btn') }}</el-button>
                    </el-form>
                </div>
                <div class="contact_info">
                    <div class="contact_info_title">{{ $t('office_contact_info') }}</div>
                    <div class="box">
                        <div class="contact_list1 contact_list1-english">
                            <div v-for="(item, i) in contacts1" :key="i">
                                <img :src="item.img" alt="" />
                                <p>{{ item.name }}</p>
                                <span>{{ item.val }}</span>
                            </div>
                        </div>
                        <div class="contact_list2">
                            <div v-for="(item, i) in contacts2" :key="i">
                                <div>
                                    <img :src="item.img" alt="" />
                                    <p>{{ item.name }}</p>
                                </div>
                                <span :title="item.val" v-if="i != 1"
                                    >{{ item.val }}<span v-show="i == 2">7 DAYS A WEEK</span></span
                                >
                                <a v-if="i == 1" :href="item.val" target="_blank"
                                    ><span> {{ $t('google_maps') }}</span></a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-aside>
                <img class="office_aside_img" src="@/assets/office_side.webp" alt="" />
                <div class="office_aside_title">{{ $t('contacts3_title') }}</div>
                <div class="contact_list3">
                    <div v-for="(item, i) in contacts3" :key="i">
                        <img :src="item.img" alt="" />
                        <p>{{ item.name }}</p>
                        <span :title="item.val" v-if="i != 1">{{ item.val }}</span>
                        <a v-if="i == 1" :href="item.val" target="_blank"
                            ><span> {{ $t('google_maps') }}</span></a
                        >
                    </div>
                </div>
            </el-aside>
        </div>
    </div>
</template>
<script>
import mixin from '@/mixin/Office'
export default {
    mixins: [mixin],
}
</script>
<style scoped src="@/styles/super.css"></style>
<style scoped lang="scss" src="@/styles/office.scss"></style>
<style lang="less" scoped>
.contact_list1-english {
    & > div {
        display: flex;
        align-items: center;
        img {
            display: block;
            top: 0;
        }
    }
}
.office-number {
    /deep/.el-select__caret {
        display: flex;
        justify-content: center;
    }
    /deep/.el-icon-arrow-up::before {
        height: 100%;
        display: flex;
        align-items: center;
    }
}
.contact_list2 {
    img {
        margin-top: 2px;
    }
    div:first-child {
        img {
            margin-top: -2px;
        }
    }
}
/deep/.el-select-dropdown__item {
    font-family: 'Lato Bold Italic' !important;
}
</style>
